import { FILE_TYPE } from "../models/models";

export const KEY_DS_DANH_MUC_TIEP_DON = "KEY_DS_DANH_MUC_TIEP_DON";
export const TOKEN = "TOKEN";

export const REGEX = {
  TEN: /^[^~`!@#$%^&*()+=\-[\]\\';,/{}|\\":<>?\d]+$/,
  AZ_09: /^[a-zA-Z0-9]*$/,
  CHARACTER20: /^.{6,20}$/,
  CHARACTER9or12: /^\d{9}(\d{3})?$/,
  CHARACTER50: /^.{1,50}$/,
  CHARACTER255: /^.{1,255}$/,
  CHECK_PHONE: /^(0|\+84)\d{9,10}$/,
  YEAR: /^(19\d\d|20\d\d|2100)$/,
};

export const NUMBER_EXCEPT_THIS_SYMBOLS = ["e", "E", "+", "-", "."];

export const CODE = {
  SUCCESS: 200,
  ISE: 500,
  ERROR_CODE_400001: 400001,
  BAD_REQUEST: 400,
  ERROR_CODE_400: 400,
  FORBIDDEN: 403,
  CONFLICT: 409,
};

export const KEY = {
  ENTER: "Enter",
  SPACE: "Space",
  F1: "F1",
  F2: "F2",
  F3: "F3",
  F4: "F4",
  F5: "F5",
  F6: "F6",
  F7: "F7",
  F8: "F8",
  F9: "F9",
  F10: "F10",
  ARROW_LEFT: "ArrowLeft",
  ARROW_RIGHT: "ArrowRight",
  ARROW_UP: "ArrowUp",
  ARROW_DOWN: "ArrowDown",
  DELETE: "Delete",
  BACKSPACE: "Backspace",
};

export const TERM_CLASS_IDS = {
  KHAM_BENH: 1,
  XET_NGHIEM: 2,
  ICD10: 4,
  CDHA: 5,
  PTTT: 6,
  KQDT: 7,
  HTXT: 8,
  LOAI_MO_BENH_AN: 11,
  HT_CHUYEN_TUYEN: 15,
  LD_CHUYEN_TUYEN: 16,
  LD_CHUYEN_TUYEN_BS: 17,
  CHUYEN_TUYEN: 18,
  VAN_CHUYEN: 31,
  NGAY_GIUONG_CHUYEN_KHOA: 32,
  DV_KHAC: 33,
};

export const LEVEL = {
  KHOA: 1,
  PHONG: 2,
};

export const DEFAULT_PAGE_INDEX = 1;
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_TOTAL_PAGES = 0;
export const DEFAULT_TOTAL_ELEMENTS = 0;
export const MAX_PAGE_SIZE = 99999;
export const INIT_SEARCH_OBJECT = {
  pageIndex: DEFAULT_PAGE_INDEX,
  pageSize: DEFAULT_PAGE_SIZE,
  type: 0,
};

export const SEARCH_OBJECT_MAX_SIZE = {
  pageIndex: DEFAULT_PAGE_INDEX,
  pageSize: MAX_PAGE_SIZE,
};

export const SELECTION_MODE = {
  SINGLE: "single",
  MULTI: "multi",
  MULTI_TABLE: "multiline",
  SINGLE_NO_RADIO_BUTTON: "singleNoRadioButton",
};

export enum TYPE {
  OBJECT = "object",
  STATUS = "status",
  STRING = "string",
  TEXT = "text",
  NUMBER = "number",
  INPUT = "input",
  DATE = "date",
  TEXTAREA = "textarea",
  SELECT = "select",
  SINGLE = "single",
  MULTI = "multi",
  MULTILINE = "multiline",
  MODULE = "module",
  PASSWORD = "password",
  EXCEL = "EXCEL",
  WORD = "WORD",
  MONEY = "MONEY",
  NUMBER_FLOAT = "NUMBER_FLOAT",
  SINGLE_NO_RADIO_BUTTON = "singleNoRadioButton",
}

export const RESPONSE_MESSAGE = {
  ADD: {
    SUCCESS: "Thêm thành công",
  },
  UPDATE: {
    SUCCESS: "Cập nhật thành công",
  },
  DELETE: {
    SUCCESS: "Xóa thành công",
  },

  ERROR: "Xảy ra lỗi, vui lòng thử lại",
};

export const CODE_SUCCESS = 200;
export const ERROR_MESSAGE = "Có lỗi xảy ra, vui lòng thử lại!";

export const VARIABLE_STRING = {
  SINGLE_MESSAGE: "errorMessage",
  MULTIPLE_MESSAGE: "message",
  YEAR: "year",
  RAW_FNC_NONAME: "function(){}",
};

export const MESSAGE = {
  CONFIRM: {
    XOA_PHIEU: "Bạn có chắc chắn muốn xóa phiếu này không?",
    XOA_DON_THUOC: "Bạn có chắc chắn muốn xóa đơn thuốc này không?",
    BO_DICH_VU_KHONG_LAM: "Bạn có chắc chắn muốn bỏ dịch vụ này không?",
    HUY_GUI_PHIEU_CDHA:
      "Bạn có chắc chắn muốn hủy gửi phiếu chẩn đoán hình ảnh này không?",
    HUY_GUI_DON_THUOC: "Bạn có chắc chắn muốn hủy gửi đơn thuốc này không?",
    HUY_GUI_PHIEU_MAU: "Bạn có chắc chắn muốn hủy gửi phiếu máu này không?",
  },
  SUCCESS: {
    HUY_GUI_PHIEU: "Đã hủy gửi phiếu thành công!",
    HUY_DON_THUOC: "Đã hủy gửi đơn thuốc thành công!",
    GUI_PHIEU: "Gửi phiếu thành công!",
    GUI_DON_THUOC: "Đã gửi đơn thuốc thành công!",
    XOA_PHIEU: "Xóa phiếu thành công!",
  },
  WARNING: {
    THAY_THE_DICH_VU_KHAC: "Dịch vụ không được phép thay thế!",
    HUY_GUI_PHIEU: "Không thế hủy phiếu vì có dịch vụ đang thực hiện!",
  },
  REQUIRED: "Trường này là bắt buộc",
};

export const ROUTES_PATH = {
  CATEGORIES: "/categories",
  HOME: "/home",
  DASHBOARD: "/dashboard",
  MENU_TEST: "/menu-test",
  BUILD_PLAN: "/build-plan",
  CRITERIA: "/criteria",
  CRITERIA_REPORT: "/criteria-report",
  REPORT_ASSIGNMENT: "/report-assignment",
  EVALUATION_REPORT: "/evaluation-report",
  CORRECTIVE_SUBSECTION: "/corrective-subsection",
};

export const BOOLEAN_TYPE_IN_NUMBER = {
  TRUE: 1,
  FALSE: 2,
};

export const overflowHiddenTable = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

export const textSystem = {
  fontWeight: "400",
  color: "#333",
  padding: "0.5rem",
};

export const FORM_CODE = {
  SO_KHAM_SUC_KHOE: "soKhamSucKhoe",
};

export const APP_DATE_TIME_FORMAT = "HH:mm DD/MM/YYYY";
export const APP_DATE_FORMAT = "DD/MM/YYYY";
export const APP_ADVANCED_DATE_FORMAT = "DD/MM/YYYY HH:mm:ss";
export const APP_DATE_REVERSE_FORMAT = "YYYY-MM-DD";
export const APP_ISO_DATE_FORMAT = "YYYY-MM-DDTHH:mm:ss";
export const APP_ISO_START_DATE_FORMAT = "YYYY-MM-DDT00:00:00";
export const APP_ISO_END_DATE_FORMAT = "YYYY-MM-DDT23:59:59";

export const FILE_EXTENSION = {
  IMAGE: "image/*",
  PDF: "application/pdf",
  DOC: "application/msword",
  DOCX: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  EXCEL: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
};

export const TERMS_CLASS_IDS_DICH_VU = `${TERM_CLASS_IDS.XET_NGHIEM},${TERM_CLASS_IDS.CDHA},${TERM_CLASS_IDS.PTTT}`;

export const INDEX_DB_KEY_TERM_MAPPER = {
  listDVKhamBenh: TERM_CLASS_IDS.KHAM_BENH,
  listKQDT: TERM_CLASS_IDS.KQDT,
  listICD10: TERM_CLASS_IDS.ICD10,
  listHTXT: TERM_CLASS_IDS.HTXT,
  listDichVu: TERMS_CLASS_IDS_DICH_VU,
};

export const actualFileType = [
  { id: FILE_TYPE.PDF, value: "application/pdf" },
  { id: FILE_TYPE.DOC, value: "application/msword" },
  { id: FILE_TYPE.DOCX, value: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" },
  { id: FILE_TYPE.XLS, value: "application/vnd.ms-excel" },
  { id: FILE_TYPE.XLSX, value: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" },
  { id: FILE_TYPE.JPG, value: "image/jpeg" },
  { id: FILE_TYPE.JPEG, value: "image/jpeg" },
  { id: FILE_TYPE.PNG, value: "image/png" },
  { id: FILE_TYPE.BMP, value: "image/bmp" },
  { id: FILE_TYPE.SVG, value: "image/svg+xml" },
  { id: FILE_TYPE.TXT, value: "text/plain" },
  { id: FILE_TYPE.CSV, value: "text/csv" },
];

export const DEFAULT_FILE_TYPES = [
  FILE_TYPE.PDF,
  FILE_TYPE.DOC,
  FILE_TYPE.DOCX,
  FILE_TYPE.XLS,
  FILE_TYPE.XLSX,
  FILE_TYPE.JPEG,
  FILE_TYPE.JPG,
  FILE_TYPE.PNG,
  FILE_TYPE.SVG
]

export const FILE_IMAGE = [FILE_TYPE.JPEG, FILE_TYPE.JPG, FILE_TYPE.PNG, FILE_TYPE.SVG];

export const LABEL_POSITION = {
  LEFT: "left",
  RIGHT: "right",
  TOP: "top",
  BOTTOM: "bottom",
};

export const TABLE_FIELD = {
  ACTION: "action",
  STT: "stt",
  TT: "tt",
}

export const DELETE_TYPE = {
  SINGLE_DELETE: 1,
  DELETE_ALL: 2,
}

export const INDEX_DB_NAME = {
  FORM_MODEL: { namePrefix: "form-", name: "formModel", keyPath: "codeAPI" },
  URL_DATA: { namePrefix: "", name: "urlData", keyPath: "url" },
};

export const ELEMENT_TAG = {
  P: 'p',
  SPAN: 'span',
  DIV: 'div',
  IMG: 'img',
  A: 'a',
  B: 'b',
}

export const DANGEROUS_HTML_PATTERNS = [
  /javascript:/i,
  /data:text\/html/i,
  /vbscript:/i,
  /on\w+\s*=/i, // event handlers như onclick, onerror
  /<script/i,
  /<iframe/i,
  /<object/i,
  /<embed/i,
  /<form/i
];

/* eslint-disable no-template-curly-in-string */
export const EXPRESSION_INTERPOLATION = {
  VALUE: "${value}",
}
/* eslint-disable no-template-curly-in-string */


export const WF_TRACKER = {
  BUILD_PLAN: "build_plan",
  CRITERIA_REPORT: "criteria_report",
  REPORT_ASSIGNMENT: "report_assignment",
  EVALUATION_REPORT: "evaluation_report",
  CORRECTIVE_SUBSECTION: "corrective_subsection",
}

export const BTN_ACTIONS = {
  EDIT: "edit",
  DELETE: "delete",
  VIEW: "view",
  DOWNLOAD: "download",
  PRINT: "print",
  COPY: "copy",
  EXPORT: "export",
  IMPORT: "import",
  ADD: "add",
  EVALUATE: "evaluate",
}

export enum CriteriaLevels {
  LEVEL_1 = 1,
  LEVEL_2 = 2,
  LEVEL_3 = 3,
  LEVEL_4 = 4,
  LEVEL_5 = 5,
}
